/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import sessionStorage from 'app/services/session';
import orderModule from 'app/store/order';
import paymentModule from 'app/store/payment';

const { setOrder } = orderModule.actions;
const { paymentStatusRequest } = paymentModule.actions;

export default function() {
  const dispatch = useDispatch();
  const wizard = useSelector(state => state.sessions.wizard);

  useEffect(() => {
    const payment = sessionStorage.getPayment();
    const order = sessionStorage.getOrder();
    const previousRoute = sessionStorage.getRoute();

    if (payment && order && !wizard.isGiftCardApplied) {
      const { userSessionId } = order;

      sessionStorage.clear();
      sessionStorage.setRoute(previousRoute);

      dispatch(setOrder(order));
      dispatch(paymentStatusRequest(userSessionId));
    }
  }, [dispatch]);
}
